import preloader from "./preloader";

export function displayFormError(form, responseError) {
    preloader(form, false);

    let alert = form.find('.danger-alert');

    alert.removeClass('d-none');

    alert.html('');

    let response = responseError !== undefined ? responseError.responseJSON : undefined;
    let errors = response !== undefined && response !== null ? response.errors : undefined;
    let printed = false;

    if(errors !== undefined && errors !== null && errors !== false){
        for(let error in errors){
            if(!errors.hasOwnProperty(error)){
                continue;
            }

            let message = Array.isArray(errors[error]) ? errors[error].join('<br>') : errors[error];

            alert.append(message + '<br>');

            printed = true;
        }
    }

    // non-json / unexpected answer (500, 419, network drop): still tell the user something
    if(!printed){
        let fallback = alert.data('fallback');

        if(response !== undefined && response !== null && response.message){
            fallback = response.message;
        }

        alert.append(fallback ? fallback : 'Error. Please try again.');
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/functions/helper.js